import { storageService as storageServiceImpl } from '../storage-service';
import type { StorageService } from './contracts';

export type { StorageService } from './contracts';
export { LocalStorageService } from '../local-storage-service';
export { LocalStorageUtil } from '../local-storage-util';
export const storageService: StorageService = storageServiceImpl;
